import { LoadingBounce } from 'components/Loading';
import { getCurrentPrincipal } from 'lib/currentPrincipal';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  useCustomerSupplierPages,
  usePrincipals,
} from '../../../../hooks/queries';
import { EmptyConfigMarketSelector } from './EmptyConfigMarketSelector';
import { MarketSelector, MarketSelectorConfig } from './MarketSelector';
import { trackSupplierPageChange } from '../../../../utils/principal-service/event-endpoints';

export const MySupplierPage: React.FC = () => {
  const { data: principals } = usePrincipals();
  const { currentPrincipal } = getCurrentPrincipal(principals);

  const { t } = useTranslation();
  const [selection, setSelection] = useState<MarketSelectorConfig | undefined>(
    undefined,
  );
  const { data: supplierPages, isLoading: isCustomerSupplierPagesLoading } =
    useCustomerSupplierPages(currentPrincipal.id);

  const selectedSupplierPage = selection
    ? supplierPages?.links.find(
        ({ country, market_segment_code, language }) =>
          country === selection?.country &&
          market_segment_code === selection?.marketSegmentId &&
          language === selection?.language,
      )
    : undefined;

  const isSelectedSupplierPageReady = !!selectedSupplierPage?.url;

  return (
    <div className="w-full" data-testid="my-supplier-page">
      <div className="max-w-xl-content mx-auto">
        {!isCustomerSupplierPagesLoading ? (
          <>
            <p>
              {t(
                'features:insights:customer-portal-insights:my-supplier-page:note',
              )}
            </p>
            <p>
              {t(
                'features:insights:customer-portal-insights:my-supplier-page:marketSelectorDescription',
              )}
            </p>
            <MarketSelector
              supplierPageOptionData={supplierPages?.links}
              currentConfigState={selection}
              onSelect={(selection) => {
                setSelection(selection);
                trackSupplierPageChange({
                  principalId: currentPrincipal.id,
                  marketSegmentCode: selection.marketSegmentId ?? '',
                  country: selection.country ?? '',
                  language: selection.language ?? '',
                });
              }}
              currentPrincipal={currentPrincipal}
            />

            {isSelectedSupplierPageReady ? (
              <iframe
                title="Customer Supplier page"
                width="100%"
                className="aspect-video"
                allowFullScreen
                src={selectedSupplierPage.url}
              />
            ) : (
              <EmptyConfigMarketSelector />
            )}
          </>
        ) : (
          <LoadingBounce />
        )}
      </div>
    </div>
  );
};
